import React from 'react'
import { CustomModal, SuccessPlaceholder } from '@components'
import { Button, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { Link } from "react-router-dom"
import PropTypes from 'prop-types';

const NotificationEmailsQueuedModal = ({ event, handleClose, show, title, queuedCount = 0 }) => {
  const message = queuedCount > 0
    ? `${queuedCount} emails have been queued for sending. These will be sent out shortly. For updates view Manage Communications or press the button below.`
    : 'Your emails have been queued for sending. These will be sent out shortly. For updates view Manage Communications or press the button below.'

  return (
    <CustomModal
      isOpen={show}
      size="2xl"
      handleClose={() => handleClose()}
      scrollBehavior="outside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>

            <ModalBody>
              <SuccessPlaceholder title="Emails have been queued" message={message}>
                <div className='flex items-center justify-center gap-3'>
                  <Button className="mt-4" size="lg" color="secondary" onPress={() => handleClose()}>
                    <Link to={`/event/${event.id}/communications`}>Manage Communications</Link>
                  </Button>

                  <Button className="mt-4" size="lg" color="default" onPress={() => handleClose()}>
                    Close
                  </Button>
                </div>
              </SuccessPlaceholder>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

NotificationEmailsQueuedModal.propTypes = {
  event: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  queuedCount: PropTypes.number,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
}

export default NotificationEmailsQueuedModal